<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="收票申请" name="first">
				<div class="k-page-common">
					<div class="k-common-header">
						<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
							<el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
								<el-form-item label="收票编码">
									<el-input v-model="searchForm.re_invoice_code" placeholder="请填写收票编码" clearable></el-input>
								</el-form-item>
								<el-form-item label="执行编码">
									<el-input placeholder="请输入执行编码" v-model="searchForm.execute_code" clearable></el-input>
								</el-form-item>
								<el-form-item label="收票类型">
									<el-select v-model="searchForm.is_platform" placeholder="请选择收票类型" clearable>
										<el-option label="供应商收票" value="1"></el-option>
										<el-option label="平台收票" value="2"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="开票方类型">
									<el-select v-model="searchForm.receive_type" placeholder="请选择开票方类型" clearable>
										<el-option label="原开票方" value="OLD"></el-option>
										<el-option label="其他开票方" value="NEW"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="开票方">
									<el-input v-model="searchForm.invoice_id" placeholder="模糊搜索开票方名称" clearable></el-input>
								</el-form-item>
								<el-form-item label="所属供应商">
									<el-select v-model="searchForm.supplier_id" filterable remote :remote-method="getSupplierSelect"
										placeholder="请选择供应商" clearable>
										<el-option v-for="item in options.supplier_id_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="申请人">
									<el-select v-model="searchForm.applicant_id" filterable remote :remote-method="getUserSelect"
										placeholder="请选择申请人" clearable>
										<el-option v-for="item in options.applicant_id_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="状态">
									<el-select v-model="searchForm.status" placeholder="请选择收票状态" clearable>
										<el-option v-for="item in options.status_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="申请时间">
									<el-date-picker v-model="searchForm.applicant_time" type="daterange" format="yyyy-MM-dd"
										value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
									</el-date-picker>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
									<el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="k-table-toolbar" style="margin-top:0;"
								v-if="$parent.$parent.isAuthAction('admin/customers/customer/applyinvoice')">
								<div>
									<el-button type="primary" size="mini" @click="addInvoiceOpen"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/applyinvoice')">收票申请</el-button>
								</div>
							</div>
							<div class="k-table-con">
								<el-table :data="tableData.data" style="width: 100%" border stripe ref="table" v-loading="tableloading"
									highlight-current-row @sort-change="sortChange" :height="tableHeight">
									<el-table-column prop="re_invoice_code" label="收票编码" width="200">
										<template slot-scope="scope">
											<el-link type="primary" style="font-size: 12px; text-decoration: underline;" :underline="false"
												@click="detail(scope.row)" target="_blank">{{ scope.row.re_invoice_code }}</el-link>
										</template>
									</el-table-column>
									<el-table-column prop="is_platform_txt" label="收票类型" width="100">
									</el-table-column>
									<el-table-column prop="receive_type_txt" label="开票方类型" width="100">
									</el-table-column>
									<el-table-column prop="invoice_id_txt" label="开票方" width="200" show-overflow-tooltip>
									</el-table-column>
									<el-table-column prop="supplier_id_txt" label="执行所属供应商" width="150">
									</el-table-column>
									<el-table-column prop="applicant_id_txt" label="申请人" width="80">
									</el-table-column>
									<el-table-column prop="receiving_id_txt" label="收票人" width="80">
										<template slot-scope="scope">
											{{ scope.row.receiving_id_txt ? scope.row.receiving_id_txt : '--' }}
										</template>
									</el-table-column>
									<el-table-column prop="invoice_cost" label="收票金额" width="100">
									</el-table-column>
									<el-table-column prop="list" label="收票明细" width="100">
										<template slot-scope="scope">
											<el-popover placement="top-start" width="480" trigger="hover">
												<el-table :data="scope.row.list" height="350" style="width: 100%;" border stripe
													highlight-current-row>
													<el-table-column width="300" property="execute_code" label="执行编码"></el-table-column>
													<el-table-column width="100" property="used_cost" label="收票金额"></el-table-column>
													<el-table-column width="80" property="status_txt" label="状态"></el-table-column>
												</el-table>
												<el-link type="primary" slot="reference" style="font-size: 12px;"
													:underline="false">查看详情</el-link>
											</el-popover>
										</template>
									</el-table-column>
									<el-table-column prop="remark" label="备注" min-width="200">
									</el-table-column>
									<el-table-column prop="applicant_time" label="申请时间" width="150">
									</el-table-column>
									<el-table-column fixed="right" prop="status_txt" align="center" label="状态" width="80">
										<template slot-scope="scope">
											<span style="font-weight: bold;">{{ scope.row.status_txt }}</span>
										</template>
									</el-table-column>
									<el-table-column fixed="right" label="操作"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/confirmsupplierinvoice') || $parent.$parent.isAuthAction('admin/customers/customer/delreinvoiceinfo') || $parent.$parent.isAuthAction('admin/customers/customer/editapplyinvoice') || $parent.$parent.isAuthAction('admin/customers/customer/returnsubmit')"
										min-width="140">
										<template slot-scope="scope">
											<el-button :disabled="!(scope.row.status == 1 || scope.row.status == 3)"
												@click="editReturnInvoice(scope.row)" type="text" :size="size"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/editapplyinvoice')">编辑</el-button>
											<el-button :disabled="!(scope.row.status == 1)" @click="addConfirmForm(scope.row)" type="text"
												:size="size"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/confirmsupplierinvoice')">提交审批</el-button>
											<el-button :disabled="!(scope.row.status == 1 || scope.row.status == 3)" type="text"
												@click="handleDelete(scope.row)" :size="size"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/delreinvoiceinfo')">删除申请</el-button>
											<el-button :disabled="!(scope.row.status == 4)" type="text" @click="handleReturn(scope.row)"
												:size="size"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/returnsubmit')">驳回</el-button>
										</template>
									</el-table-column>
								</el-table>
								<el-pagination background ref="pagination" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="tableData.page | number"
									:page-size="tableData.pagesize | number" :page-sizes="[15, 30, 50, 100]"
									layout="prev, pager, next, sizes, total" :total="tableData.total | number">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--申请收票-->
		<el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" :close-on-press-escape='false'
			:wrapperClosable='false' size="90%">
			<el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px"
				v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>申请收票</span>
						<i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content">
					<el-form-item label="供应商" prop="supplier_id">
						<el-select v-model="addForm.supplier_id" filterable remote placeholder="请选择供应商" clearable
							@change="getExecuteSelectss" :remote-method="getSupplierSelect" style="width:100%;">
							<el-option v-for="item in options.supplier_id_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="项目" prop="project_id" v-if="addForm.supplier_id">
					<el-select v-model="addForm.project_id" filterable remote :remote-method="getProjectlist" clearable placeholder="请输入您要搜索的项目名称" style='width: 100%;' @change="getSuppSelectss()">
						<el-option v-for="item in options.project_ids_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item> -->
					<el-form-item label="执行" prop="execute_ids" v-if="addForm.supplier_id">
						<el-select v-model="addForm.execute_ids" multiple filterable remote clearable placeholder="可搜索执行编码"
							style='width: 100%;' @change="addExecuteIds" :remote-method="getExecuteSelect">
							<el-option v-for="item in options.execute_ids_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<div style="padding-top: 8px; color: #F56C6C; font-size:13px;" v-if="execute_tips">{{ execute_tips }}</div>
					</el-form-item>
					<el-row v-for="(item, index) in invoice_array" :key="index"
						v-if="invoice_array.length > 0 && addForm.invoice_array[0].execute_code">
						<el-form-item style="margin-bottom: 0;">
							<el-col :span="7">
								<el-form-item label="执行编码:" label-width="78px">
									<el-input v-model="addForm.invoice_array[index].execute_code" clearable disabled></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="发票录入:" :prop="`invoice_array[${index}].invioce_lr_id`" :rules="[{
									required: true, validator: (rule, value, callback) => {
										if (!value) {
											callback('请选择发票录入')
										} else {
											callback()
										}
									}, trigger: 'blur'
								}]">
									<el-select v-model="addForm.invoice_array[index].invioce_lr_id" filterable remote clearable
										placeholder="请选择发票录入" style='width: 100%;' @change="getCost(index)" :remote-method="getInviocelrId">
										<el-option v-for="item in options.invioce_lr_id_options" :key="item.value" :label="item.label"
											:value="item.value"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="使用金额:" :prop="`invoice_array[${index}].cost`"
									:rules="[{ required: true, validator: validatorLrId, trigger: 'blur' }]">
									<el-input v-model="addForm.invoice_array[index].cost" placeholder="请填写使用金额"></el-input>
								</el-form-item>
							</el-col>
						</el-form-item>
					</el-row>
					<el-form-item label="开票方" v-if="addForm.execute_ids.length > 0">
						<el-radio-group v-model="addForm.receive_type" @input="getNewSupplier">
							<el-radio label="OLD">原开票方</el-radio>
							<el-radio label="NEW">其他开票方</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="其他供应商" prop="new_supplier_id" v-if="addForm.receive_type == 'NEW'">
						<el-select style="width:100%;" v-model="addForm.new_supplier_id" filterable remote placeholder="请选择供应商"
							clearable @change="getInvoiceInfo" :remote-method="getSupplierNew">
							<el-option v-for="item in options.new_supplier_id_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="开票信息" prop="invoice_id" v-if="addForm.execute_ids.length > 0">
						<el-select v-model="addForm.invoice_id" filterable placeholder="请选择开票信息" clearable style="width:100%;">
							<el-option v-for="item in options.invoice_id_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="申请备注">
						<el-input type="textarea" v-model="addForm.remark" placeholder="请填写申请备注" clearable></el-input>
					</el-form-item>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="addInvoice('SAVE')" :size='size'
						:disabled="invoiceSubmitDisabled">保存</el-button>
					<el-button type="danger" @click="addInvoice('SUBMIT')" :size='size'
						:disabled="invoiceSubmitDisabled">提交</el-button>
					<!-- <el-button type="primary" @click="addInvoice" :size='size'>提交</el-button> -->
					<el-button :size='size' @click="addFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
	</div>
</template>
<script>
export default {
	props: ['info'],
	data () {
		return {
			addFormVisiable: false,
			editFormVisiable: false,
			invoiceSubmitDisabled: false,
			loading: false,
			tableloading: true,
			activeName: 'first',
			size: 'mini',
			options: {
				project_ids_options: [],
				status_options: [
					{
						value: 1,
						label: '待提交'
					}, {
						value: 2,
						label: '待审核'
					}, {
						value: 3,
						label: '已驳回'
					}, {
						value: 4,
						label: '正常'
					}
				],
				qr_status_options: [
					{
						value: 3,
						label: '收票'
					}, {
						value: 2,
						label: '驳回'
					}
				],
				invoice_type_options: [
					{
						value: 1,
						label: '普票'
					}, {
						value: 2,
						label: '专票'
					}, {
						value: 3,
						label: '形式发票'
					}
				],
				invoice_status_options: [
					{
						value: 1,
						label: '收票'
					}, {
						value: 2,
						label: '开票'
					}
				],
				invoice_id_options: [],
				new_supplier_id_options: [],
				supplier_id_options: [],
				applicant_id_options: [],
				execute_ids_options: [],//执行下拉列表
				invioce_lr_id_options: []//发票录入下拉列表
			},
			searchForm: {
				re_invoice_code: '',
				execute_code: '',
				receive_type: '',
				invoice_id: '',
				is_platform: '',
				supplier_id: '',
				applicant_id: '',
				status: '',
				applicant_time: ''
			},
			resetSearch: {
				re_invoice_code: '',
				execute_code: '',
				receive_type: '',
				invoice_id: '',
				is_platform: '',
				supplier_id: '',
				applicant_id: '',
				status: '',
				applicant_time: ''
			},
			addForm: {
				project_id: '',
				supplier_id: '',
				new_supplier_id: '',
				receive_type: 'OLD',
				execute_ids: [],
				invoice_id: '',
				invoice_array: [{
					execute_id: '',
					invioce_lr_id: '',
					cost: '',
					execute_code: ''
				}],
				remark: ''
			},
			confirmForm: {
				id: '',
				status: '',
				remark: ''
			},
			rules: {
				addForm: {
					'project_id': [
						{ required: true, message: '请选择项目', trigger: ['change'] }
					],
					'supplier_id': [
						{ required: true, message: '请选择供应商', trigger: ['change'] }
					],
					'invoice_id': [
						{ required: true, message: '请选择开票信息', trigger: ['change'] }
					],
					'execute_ids': [
						{ required: true, message: '请选择执行', trigger: ['change'] }
					]
				},
				confirmForm: {
					'status': [
						{ required: true, message: '请选择状态', trigger: ['change'] }
					],
					'remark': [
						{
							validator: (rule, value, callback) => {
								if (!value && this.confirmForm.status == 2) {
									callback(new Error('请填写备注信息'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
				}
			},
			tableData: {
				total: 0,
				pagesize: 15,
				page: 1,
				data: []
			},
			invoice_array: [],//发票信息集合
			execute_tips: ''//执行提示
		}
	},
	computed: {
		isSupper: function () {
			return this.info.views.isSupper
		},
		tableHeight: function () {
			return window.innerHeight - 320;
		}
	},
	watch: {
	},
	mounted: function () {
		//this.handleSearch(this.searchForm);
		this.getSupplierSelect()//获取供应商下拉
		this.getUserSelect()//获取供应商下拉
	},
	methods: {
		// 修改时获取相关信息
		editReturnInvoice (row) {
			// 获取收票票信息单条详情
			this.$api.get('/admin/customers/customer/getreturninviceinfo', { id: row.id }).then(res => {
				if (res.code === 0) {
					this.$set(this, 'addForm', JSON.parse(JSON.stringify(res.data)))
					this.addFormVisiable = true
					this.getSupplierSelect(res.data.sup_name, () => {
						this.getExecuteSelect('', () => {
							this.$set(this.addForm, 'invoice_array', res.data.invoice_array)
							this.getInviocelrId('', () => {
								this.$set(this.addForm, 'execute_ids', res.data.execute_ids)
								this.$set(this.addForm, 'invoice_array', res.data.invoice_array)
								this.$set(this, 'invoice_array', res.data.invoice_array)
							})
						})
					})
					if (res.data.receive_type == 'OLD') {
						this.getInvoiceInfo(res.data.supplier_id)
					} else {
						this.getSupplierNew(res.data.sup_name_new)
						this.getInvoiceInfo(res.data.new_supplier_id)
					}
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		addConfirmForm (row) {
			this.loading = true
			this.$api.post('/admin/customers/customer/confirmsupplierinvoice', { id: row.id }).then(res => {
				if (res.code === 0) {
					var data = this.tableData.data;
					data.forEach(function (item, index) {
						if (row.id == item.id) {
							this.$set(data[index], 'status_txt', '待审核');
							this.$set(data[index], 'status', 2);
						}
					}.bind(this));
					this.$message({
						showClose: true,
						message: '该申请已进入审批流程，等待审核！',
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		getNewSupplier (value) {
			this.addForm.new_supplier_id = ''
			this.addForm.invoice_id = ''
			if (value == 'NEW') {
				this.getSupplierNew()
			} else {
				this.getInvoiceInfo(this.addForm.supplier_id)
			}
		},
		getInvoiceInfo (value) {
			this.$api.get('/admin/resources/resources/supinvoicedw', { sid: value, relevance: 1, is_platform_view: 'supplier_id' }).then(res => {
				if (res.code === 0) {
					this.options.invoice_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		getSupplierNew (query) {
			query = query ? query : '';
			this.$api.get('/admin/resources/resources/supldwn', { query: query, is_geren: 'NO' }).then(res => {
				if (res.code === 0) {
					this.options.new_supplier_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		getProjectlist (query) {
			this.$api.get('/admin/news/message/getprojectselect', { 'query': query }).then(res => {
				if (res.code === 0) {
					this.options.project_ids_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		getSupplierSelect (query, fun) {
			query = query ? query : '';
			this.$api.get('/admin/resources/resources/supldwn', { query: query, is_geren: 'NO' }).then(res => {
				if (res.code === 0) {
					this.options.supplier_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				if (typeof fun === 'function') {
					fun();
				}
			})
		},
		getUserSelect (query) {
			query = query ? query : '';
			this.$api.post('/admin/users/user/getuserbydepartment', { query: query }).then(res => {
				if (res.code === 0) {
					this.options.applicant_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		handleReturn (row) {
			this.$confirm('此操作将驳回该条记录, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.$api.post('/admin/customers/customer/returnsubmit', { id: row.id }).then(res => {
					if (res.code === 0) {
						this.handleSearch(this.searchForm)
						this.$message({
							showClose: true,
							message: '该申请已成功驳回！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
				})
			}.bind(this))
		},
		handleDelete (row) {
			this.$confirm('此操作将永久删除该条申请, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.tableloading = true;
				this.$api.delete('/admin/customers/customer/delreinvoiceinfo', { id: row.id }).then(res => {
					if (res.code === 0) {
						var data = this.tableData.data;
						data.forEach(function (item, index) {
							if (item.id == row.id) {
								this.$delete(data, index);
							}
						}.bind(this));
						this.$message({
							showClose: true,
							message: '该申请已成功删除！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.tableloading = false
				})
			}.bind(this))
		},
		validatorLrId (rule, value, callback) {
			let result = rule.field.match(/\[(.*?)\]/);
			let index = result[1]
			if (this.addForm.invoice_array[index].invioce_lr_id) {
				if (!value) {
					callback('请填写使用金额')
				} else {
					if (!isNaN(Number(value)) && value > 0) {
						//实时验证可用票面金额-------发票录入
						this.$api.post('/admin/customers/customer/invoicevalidate', { id: this.addForm.invoice_array[index].invioce_lr_id, invoice_array: this.addForm.invoice_array }).then(res => {
							if (res.code === 0) {
								if (res.data.maxCost < 0) {
									// callback('已超出最大可使用金额')
									callback(res.data.msg)
								} else {
									//获取当前index的发票录入id相同的对象的索引
									let val = this.addForm.invoice_array[index].invioce_lr_id
									let indices = [];
									for (let i = 0; i < this.addForm.invoice_array.length; i++) {
										if (this.addForm.invoice_array[i].invioce_lr_id === val) {
											indices.push(i);
										}
									}
									for (let i = 0; i < indices.length; i++) {
										let newval = indices[i]
										//清楚所有相同索引的报错信息
										this.$nextTick(() => {
											this.$refs['addForm'].clearValidate(`invoice_array[${newval}].cost`);
										});
									}
									callback()
								}
							} else {
								this.$message.error(res.msg);
							}
						})

					} else {
						callback('使用金额必须为数字且必须大于0')
					}
				}
			} else {
				callback('请先选择发票录入')
			}
		},
		handleSearch: function (params, page, prop, order) {
			this.tableloading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/customers/customer/getreinvoicelist', param).then(res => {
				if (res.code === 0) {
					this.tableData = res.data;
					this.$nextTick(() => {
						if (this.$refs.table) {
							this.$refs.table.doLayout();
						}
					});
				} else {
					this.$message.error(res.msg);
				}
				this.tableloading = false
			})
		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset () {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			} else {
				prop = this.resetSearch.prop;
				order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},
		getSuppSelectss () {
			this.addForm.supplier_id = ''
			this.addForm.new_supplier_id = '',
				this.addForm.execute_ids = []
			this.addForm.receive_type = 'OLD'
			this.addForm.invoice_id = ''
			this.addForm.invoice_array = [{
				execute_id: '',
				invioce_lr_id: '',
				cost: '',
				execute_code: ''
			}]
			this.execute_tips = ''
			this.getSupplierSelect()
		},
		getExecuteSelectss (value) {
			this.addForm.execute_ids = []
			this.addForm.receive_type = 'OLD'
			this.addForm.invoice_id = ''
			this.addForm.invoice_array = [{
				execute_id: '',
				invioce_lr_id: '',
				cost: '',
				execute_code: ''
			}]
			this.execute_tips = ''
			this.getExecuteSelect()
			this.getInviocelrId()//获取发票录入下拉
		},
		//获取执行列表
		getExecuteSelect (query, fun) {
			query = query || '';
			this.$api.get('/admin/customers/customer/getexecuteselect', { 'query': query, 'status': 'applyinvoice', 'project_id': this.addForm.project_id, 'supplier_id': this.addForm.supplier_id, 'public_id': this.addForm.execute_ids }).then(res => {
				if (res.code === 0) {
					this.options.execute_ids_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				if (typeof fun === 'function') {
					fun();
				}
			})
		},
		//获取发票录入下拉
		getInviocelrId (query, fun) {
			query = query || '';
			var ids = this.addForm.invoice_array.map(item => item.invioce_lr_id);
			// status: true,
			this.$api.get('/admin/customers/customer/getinvioceentryselect', { 'query': query, 'invoice_status': 1, ids: ids }).then(res => {
				if (res.code === 0) {
					this.options.invioce_lr_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				if (typeof fun === 'function') {
					fun();
				}
			})
		},
		//根据所选执行生成对应表格数据
		addExecuteIds () {
			this.$api.get('/admin/customers/customer/getexecuteselect', { 'public_id': this.addForm.execute_ids, 'status': 'applyinvoice' }).then(res => {
				if (res.code === 0) {
					var sup_ids = []
					var plate = []
					var isplateform = []
					res.data.forEach(function (item) {
						if (this.addForm.execute_ids.indexOf(item['id']) != -1) {
							if (plate.indexOf(item['platform_id']) == -1) {
								plate.push(item['platform_id'])
							}
							if (isplateform.indexOf(item['is_platform_order']) == -1) {
								isplateform.push(item['is_platform_order'])
							}
							if (sup_ids.indexOf(item['supplier_id']) == -1) {
								sup_ids.push(item['supplier_id'])
							}
						}
					}.bind(this))
					if (isplateform[0] == 'YES' && plate.length > 1) {
						this.$message.error('走平台订单所有记录均为同平台才可申请收票，请重新选择')
						this.addForm.execute_ids = []
						return
					}
					if (isplateform[0] == 'NO' && sup_ids.length > 1) {
						this.$message.error('非平台订单,选中的记录必须是同一供应商，请重新选择')
						this.addForm.execute_ids = []
						return
					}
					// this.options.execute_ids_options = res.data;
					const filteredOptions = res.data.filter(opt => this.addForm.execute_ids.includes(opt.value));
					this.invoice_array = filteredOptions.map(item => ({ execute_id: item.value, execute_code: item.code, invioce_lr_id: "", cost: item.price }));
					this.addForm.invoice_array = filteredOptions.map(item => ({ execute_id: item.value, execute_code: item.code, invioce_lr_id: "", cost: item.price }));
					//获取申请收票界面可收票金额--------执行
					if (this.addForm.execute_ids.length > 0) {
						this.$api.get('/admin/customers/customer/getapplyinvoicecost', { execute_ids: this.addForm.execute_ids }).then(res => {
							if (res.code === 0) {
								this.execute_tips = res.msg
							} else {
								this.$message.error(res.msg);
							}
						})
					} else {
						this.execute_tips = ''
					}
				}
			})
			this.getInvoiceInfo(this.addForm.supplier_id)
		},
		//根据发票录入获取对应
		getCost (index) {
			// this.addForm.invoice_array[index].cost = ''
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate(`invoice_array[${index}].cost`);
			});
		},
		// 申请收票弹窗
		addInvoiceOpen () {
			this.addForm = {
				project_id: '',
				supplier_id: '',
				receive_type: 'OLD',//收票方类型
				invoice_id: '',
				execute_ids: [],
				invoice_array: [{
					execute_id: '',
					invioce_lr_id: '',
					cost: '',
					execute_code: ''
				}],
				remark: ''
			}
			this.invoice_array = []
			this.execute_tips = ''
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
			// this.getProjectlist()
			this.getSuppSelectss()
			this.addFormVisiable = true;
		},
		// 申请收票
		addInvoice (type) {
			if (this.invoiceSubmitDisabled) return;
			// 先置灰，防止 validate 异步期间用户重复点击
			this.invoiceSubmitDisabled = true;
			// 获取提交类型，SAVE是保存，SUBMIT是提交
			this.addForm['submit_type'] = type
			this.$refs['addForm'].validate(function (valid) {
				if (valid) {
					var request_data = JSON.parse(JSON.stringify(this.addForm));
					if (request_data.receive_type == 'NEW') {
						request_data['supplier_id'] = request_data['new_supplier_id']
					}
					delete request_data['new_supplier_id']
					// 有id则证明是修改
					if (request_data['id']) {
						this.$api.post('/admin/customers/customer/editapplyinvoice', request_data).then(res => {
							if (res.code === 0) {
								this.addFormVisiable = false;
								this.$message({
									showClose: true,
									message: '修改申请收票成功！',
									type: 'success'
								});
								// 重新加载表格
								this.handleSearch()
							} else {
								this.$message.error(res.msg)
							}
							this.invoiceSubmitDisabled = false;
						}).catch(() => {
							this.invoiceSubmitDisabled = false;
						})
					} else {
						this.$api.post('/admin/customers/customer/applyinvoice', request_data).then(res => {
							if (res.code === 0) {
								this.addFormVisiable = false;
								this.$message({
									showClose: true,
									message: '申请收票成功！',
									type: 'success'
								});
								// 重新加载表格
								this.handleSearch()
							} else {
								this.$message.error(res.msg);
							}
							this.invoiceSubmitDisabled = false;
						}).catch(() => {
							this.invoiceSubmitDisabled = false;
						})
					}


				} else {
					// 校验失败也需要释放按钮
					this.invoiceSubmitDisabled = false;
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},

		//打开详情页
		detail (row) {
			this.$router.push({
				name: 'InvoiceCollectDetail',
				query: { id: row.id, set_id: 3, type: 'detail' }
			});
		},
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			// 使用 === 进行严格相等判断
			if (from.path !== '/invoiceCollectDetail') {
				try {
					vm.reset();
				} catch (error) {
				}
			}
		});
	}
}
</script>
<style type="text/css" scoped>
.el-table .el-form-item--mini.el-form-item,
.el-table .el-form-item--small.el-form-item {
	margin-bottom: 0;
}
</style>